export default class ViewStudentAccountController {
    // @ngInject
    constructor(targetUser, schoolId) {
        this.targetUser = targetUser;
        this.schoolId = schoolId;
    }
}
